__turbopack_context__.v({
  "downshiftInput": "_0O2a5q_downshiftInput",
  "freeTermsButton": "_0O2a5q_freeTermsButton",
  "inputWrapper": "_0O2a5q_inputWrapper",
  "itemLabel": "_0O2a5q_itemLabel",
  "itemsWrapper": "_0O2a5q_itemsWrapper",
  "spanElement": "_0O2a5q_spanElement",
});
